import { render, staticRenderFns } from "./CN22.vue?vue&type=template&id=541b8b90&scoped=true&"
import script from "./CN22.vue?vue&type=script&lang=js&"
export * from "./CN22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541b8b90",
  null
  
)

export default component.exports